import { useEffect } from 'react';
import { getArtText } from '../domain/art-text-provider';
import PreloaderIcon from './icons/PreloaderIcon';
import { rootActions, useAppDispatch, useAppSelector } from '../data/store';

const ArtText = () => {

    const dispatch = useAppDispatch();

    const loading = useAppSelector(store => store.root.loading);

    const text = useAppSelector(store => store.root.text);
    const artTextSVG = useAppSelector(store => store.root.artTextSVG);

    const iconsData = useAppSelector(store => store.root.iconsData);
    const icons = useAppSelector(store => store.form.icons);
    const category = useAppSelector(store => store.root.category);

    const colors = useAppSelector(store => store.form.colors);
    const backgroundColor = useAppSelector(store => store.form.backgroundColor);
    const backgroundColorEnabled = useAppSelector(store => store.form.backgroundColorEnabled);

    useEffect(() => {
        (async () => {

            dispatch(
                rootActions.main({
                    loading: true,
                })
            );

            const svg = await getArtText(
                text,
                icons,
                colors,
                backgroundColor,
                backgroundColorEnabled
            );

            dispatch(
                rootActions.main({
                    artTextSVG: svg,
                    loading: false,
                })
            );
        })();
    },
    [
        dispatch, icons,
        category, iconsData, text, colors,
        backgroundColor, backgroundColorEnabled
    ]);

    return (
        <>
            { loading &&  <div className="mx-auto"><PreloaderIcon width="50" height="50" color="#555" /></div> }

            {
                !loading && artTextSVG &&
                <div className="mx-auto" dangerouslySetInnerHTML={{ __html: artTextSVG }}></div>
            }
        </>
    )
};

export default ArtText;